import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrganizations = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 10C1 8.89543 1.89543 8 3 8H6C7.10457 8 8 8.89543 8 10V22H1V10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 2C5.89543 2 5 2.89543 5 4V6H7C7 5.44772 7.44772 5 8 5H9C9.55228 5 10 5.44772 10 6V7C10 7.27588 9.88829 7.52566 9.70763 7.70659C9.89505 8.09822 10 8.53685 10 9V11V12V16V17V22H17V4C17 2.89543 16.1046 2 15 2H7ZM12 6C12 5.44772 12.4477 5 13 5H14C14.5523 5 15 5.44772 15 6V7C15 7.55228 14.5523 8 14 8H13C12.4477 8 12 7.55228 12 7V6ZM13 10C12.4477 10 12 10.4477 12 11V12C12 12.5523 12.4477 13 13 13H14C14.5523 13 15 12.5523 15 12V11C15 10.4477 14.5523 10 14 10H13ZM12 16C12 15.4477 12.4477 15 13 15H14C14.5523 15 15 15.4477 15 16V17C15 17.5523 14.5523 18 14 18H13C12.4477 18 12 17.5523 12 17V16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 22H23V13C23 11.8954 22.1046 11 21 11H19V22Z",
			fill: "currentColor"
		})
	]
});
export default SvgOrganizations;
